
import { mapGetters } from 'vuex'
import { isNull } from 'lodash'
import ButtonRoundGreen from '~/components/Buttons/ButtonRound/ButtonRoundGreen'
import { api } from '~/config/api'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import SelectWithOptionsSearchItemsObject from '~/ZenOne-StoryBook/components/SelectWithOptionsSearchItemsObject'

export default {
  name: 'RequestMissingProductDialog',
  components: { SelectWithOptionsSearchItemsObject, ButtonRoundGreen },
  mixins: [ui],
  data() {
    return {
      dialog: false,
      distributorId: null,
      sku: null,
    }
  },
  computed: {
    ...mapGetters({
      distributorsOverallOrigin: 'catalog/distributorsOverall',
      practiceLocationId: 'user/practiceLocationId',
      practiceLocationName: 'user/practiceLocationName',
      showFullScreenLoader: 'ui/showFullScreenLoader',
    }),
    distributorsOverall() {
      return this.distributorsOverallOrigin.map((d) => {
        return {
          id: d?.id ? d.id.toString() : null,
          name: d?.name ?? '',
        }
      })
    },
    isActionBtnDisabled() {
      return (
        this.showFullScreenLoader || isNull(this.distributorId) || !this.sku
      )
    },
  },
  methods: {
    open() {
      this.dialog = true
    },
    closeBtnClickHandler() {
      this.close()
    },
    close() {
      this.dialog = false
      this.distributorId = null
      this.sku = null
    },
    async sendRequestBtnClickHandler() {
      await this.sendRequest()
    },
    async sendRequest() {
      try {
        const {
          distributorId = null,
          practiceLocationId = null,
          sku = null,
        } = this
        if (!distributorId) throw new Error('Please select distributor')
        if (!sku) throw new Error('Please type sku')
        if (!practiceLocationId) throw new Error('No practice location id')
        this.showFSLoader()
        await this.$axios.post(`/${api.ZEN_REP_TASKS}`, {
          title: 'Add missing product',
          system_type: 'add_missing_product',
          params: {
            distributorId: parseInt(distributorId),
            practiceLocationId: parseInt(practiceLocationId),
            sku: this.sku,
          },
        })
        this.$emit('show-success-modal')
      } catch (e) {
        const error = `Request missing product: ${
          e?.response?.data?.errors?.[0]?.detail ?? e
        }`
        console.error(error)
        this.showAlert({
          type: this.ERROR,
          content: error,
        })
      } finally {
        this.hideFSLoader()
        this.close()
      }
    },
  },
}
